/**
 * Tool-name parsing, with no dependencies.
 *
 * This lives apart from `hooks/agent-stream` deliberately. That module imports
 * the i18n instance and the auth/transport layer, so anything that pulls
 * `splitToolName` from it drags a whole app bootstrap along - which is exactly
 * what broke `thread-message-converter`'s tests, a pure function with no other
 * runtime needs.
 */

/**
 * Split a tool name into [scope, action], handling both the dot-notation id
 * ("profile.get") and the camelCase registry key ("profileGet") the stream
 * actually carries.
 *
 * Verb-first families (connectors, memory) do not decompose into entity+action:
 * `sendEmail` yields ["send", "email"], i.e. the VERB lands in the scope slot.
 * Callers that need readable copy for those handle them by name.
 */
export function splitToolName(toolName: string): [string, string] {
  if (toolName.includes('.')) {
    const [scope = '', action = ''] = toolName.split('.');
    return [scope, action];
  }
  // camelCase: "profileGet" -> ["profile", "get"], "cvUpdateSummary" -> ["cv", "updateSummary"]
  const match = toolName.match(/^([a-z]+)([A-Z].*)$/);
  if (match) {
    const scope = match[1]!;
    const action = match[2]!.charAt(0).toLowerCase() + match[2]!.slice(1);
    return [scope, action];
  }
  return [toolName, ''];
}
